import { Alert, Grid } from "@mui/material";
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

// Components
import { Form, Input, Select, Slider, ToggleSwitch } from 'Components';
import { MILES_TO_KPH } from "../../../../../../../../core/data/Helpers";

//VBus
export const LightDutyDTC = (props) => {
  const { value, onChange, formRef, currentAlert, setCurrentAlert } = props
  const { messages } = useIntl()
  const isKph = useSelector((state) => state.securityRedux.user.isKph)
  const [showErrorTrigger, setShowErrorTrigger] = useState(false)
  const [seatbeltUM, setSeatbeltUM] = useState(value.seatbelt || null)

  useEffect(() => {
    if (isKph) {
      value.seatbelt = Math.floor(seatbeltUM * MILES_TO_KPH);
      setSeatbeltUM(value.seatbelt)
    }
  }, [])

  useEffect(() => {
    if (value.dtc == undefined){
      onChange({
        ...value,
        dtc: false
      })
    }

    setTimeout(() => {
      setCurrentAlert({ ...currentAlert, conditions: { isVbus: true } })
    }, 1000)
  }, [value])

  /** VARS */
  const status = useMemo(() => [
    { id: 1, name: messages['on'] },
    { id: 0, name: messages['off'] }
  ], [messages])

  const voltages = useMemo(() => {
    let values = []
    let voltage = 6
    while (voltage < 14) {
      values.push({
        id: voltage,
        name: `${`${voltage}`.length > 2 ? voltage : `${voltage}.0`}`
      })
      voltage = voltage + 0.5
    }
    return values
  }, [])

  const rpms = useMemo(() => {
    let values = []
    let rpm = 500
    while (rpm < 10001) {
      values.push({
        id: rpm,
        name: rpm
      })
      rpm = rpm + 500
    }
    return values
  }, [])

  const fuelLevels = useMemo(() => {
    let values = []
    let fuelLevel = 0
    while (fuelLevel < 101) {
      values.push({ id: fuelLevel, name: `${fuelLevel}` })
      fuelLevel = fuelLevel + 5
    }
    return values
  }, [])

  const fuelRates = useMemo(() => {
    let values = [];
    values.push({ id: 0.1, name: `0.1` });
    let fuelRate = 0.5;
    while (fuelRate < 5.1) {
      values.push({
        id: fuelRate,
        name: `${`${fuelRate}`.length > 1 ? fuelRate : `${fuelRate}.0`}`
      });
      fuelRate = fuelRate + 0.5;
    }
    return values
  }, [])

  const positions = useMemo(() => {
    let values = []
    let position = 5
    while (position < 101) {
      values.push({
        id: position,
        name: `${position}`
      })
      position = position + 5
    }
    return values
  }, [])

  const speeds = useMemo(() => {
    let values = []
    let speed = 15
    while (speed < 151) {
      values.push({
        id: speed,
        name: `${speed}`
      })
      speed = speed + 1
    }
    return values
  }, [])

  const isValidRequiredItems = useCallback((clickNext = false) => {
    let isValid = false
    // validate all fields
    if (Object.values(value).some(v => (v != undefined && v !== false && v !== ''))) {
      isValid = true
    }
    if (value.trigger && clickNext) {
      setShowErrorTrigger(!isValid)
    }
    return isValid
  }, [value])

  return (
    <Form ref={formRef}
      onSubmit={() => {
        if (isKph) {
          value.seatbelt = seatbeltUM ? seatbeltUM / MILES_TO_KPH : null;
        }
        return isValidRequiredItems(true)
      }}
    >
      <Grid container justifyContent={'center'} direction={'column'} style={{ paddingTop: 15 }}>

        <div style={{ display: 'grid', paddingBottom: 10 }}>
          {
            (!isValidRequiredItems()) &&
            <small className="text-danger" style={{ marginTop: -5 }}>
              {messages["alertsNewAlert_BusValidation"]}
            </small>
          }
        </div>

        <div className="title_divider">{messages['alertsNewAlert_Bus_DiagnosticTroubleshootingCodes']}</div>

        { /* dtc */}
        <Grid item style={{ display: 'flex' }}>
          <ToggleSwitchWrapper
            id='dtc'
            label={messages['alertsNewAlert_VBus_EngineCode']}
            checked={value.dtc == 1}
            onChange={(newValue) => onChange({ ...value, dtc: newValue })}
            xs={12} sm={12}
          />
        </Grid>

        <Grid style={{ padding: "10px 0" }} item>
          <Alert severity="warning">{messages['alertsNewAlert_Bus_NotAllFieldsAvailableToAlert']}</Alert>
        </Grid>

        <div className="title_divider">{messages['alertsNewAlert_VBus_SystemIndicators']}</div>

        { /* absActiveLamp - abs */}
        <Grid item style={{ display: 'flex' }}>
          <ToggleSwitchWrapper
            id='absActiveLamp'
            label={messages['alertsNewAlert_VBus_AbsActiveLamp']}
            checked={value.absActiveLamp == 1}
            onChange={(newValue) => onChange({ ...value, absActiveLamp: newValue })}
            xs={6} sm={6}
          />

          <ToggleSwitchWrapper
            id='abs'
            label={messages['alertsNewAlert_VBus_Abs']}
            checked={value.abs == 1}
            onChange={(newValue) => onChange({ ...value, abs: newValue })}
            xs={6} sm={6}
          />
        </Grid>

        { /* airbagIndicator - brakeIndicator */}
        <Grid item style={{ display: 'flex' }}>
          <ToggleSwitchWrapper
            id='airbagIndicator'
            label={messages['alertsNewAlert_VBus_AirbagIndicator']}
            checked={value.airbagIndicator == 1}
            onChange={(newValue) => onChange({ ...value, airbagIndicator: newValue })}
            xs={6} sm={6}
          />

          <ToggleSwitchWrapper
            id='brakeIndicator'
            label={messages['alertsNewAlert_VBus_BrakeIndicator']}
            checked={value.brakeIndicator == 1}
            onChange={(newValue) => onChange({ ...value, brakeIndicator: newValue })}
            xs={6} sm={6}
          />
        </Grid>

        { /* oilPressure - coolantLight */}
        <Grid item style={{ display: 'flex' }}>
          <ToggleSwitchWrapper
            id='oilPressure'
            label={messages['alertsNewAlert_VBus_OilPressure']}
            checked={value.oilPressure == 1}
            onChange={(newValue) => onChange({ ...value, oilPressure: newValue })}
            xs={6} sm={6}
          />

          <ToggleSwitchWrapper
            id='coolantLight'
            label={messages['alertsNewAlert_VBus_CoolantHotLight']}
            checked={value.coolantLight == 1}
            onChange={(newValue) => onChange({ ...value, coolantLight: newValue })}
            xs={6} sm={6}
          />
        </Grid>

        { /* cruiseControl - milStatus */}
        <Grid item style={{ display: 'flex' }}>
          <ToggleSwitchWrapper
            id='cruiseControl'
            label={messages['alertsNewAlert_VBus_CruiseControl']}
            checked={value.cruiseControl == 1}
            onChange={(newValue) => onChange({ ...value, cruiseControl: newValue })}
            xs={6} sm={6}
          />

          <ToggleSwitchWrapper
            id='milStatus'
            label={messages['alertsNewAlert_VBus_MilStatus']}
            checked={value.milStatus == 1}
            onChange={(newValue) => onChange({ ...value, milStatus: newValue })}
            xs={6} sm={6}
          />
        </Grid>

        { /* pto */}
        <Grid item style={{ display: 'flex' }}>
          <ToggleSwitchWrapper
            id='pto'
            label={messages['alertsNewAlert_VBus_PtoStatus']}
            checked={value.pto == 1}
            onChange={(newValue) => onChange({ ...value, pto: newValue })}
            xs={6} sm={6}
          />
        </Grid>

        { /* brake */}
        <Grid item style={{ display: 'flex' }}>
          <SelectWrapper
            id='brake'
            placeholder={messages['alertsNewAlert_Bus_NotSet']}
            label={messages['alertsNewAlert_VBus_BrakeSwitchStatus']}
            value={status.find((option) => option.id === value.brake)}
            options={status}
            onChange={(selected) => onChange({ ...value, brake: selected?.id })}
            xs={12} sm={12}
          />
        </Grid>

        <div className="title_divider">{messages['alertsNewAlert_VBus_Thresholds']}</div>

        { /* batteryVoltage */}
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
          style={{ width: '100%' }}
        >
          <Grid item xs={12} sm={12} style={{ paddingTop: 10 }}>
            <label>
              {messages['alertsNewAlert_VBus_BatteryVoltage']}
            </label>
          </Grid>

          <SliderWrapper
            min={6}
            max={13.5}
            value={value.batteryVoltage || 0}
            onChange={(selected) => onChange({ ...value, batteryVoltage: selected })}
            sliderStep={0.5}
            xs={12} sm={9}
          />

          <SelectWrapper
            id='batteryVoltage'
            placeholder={messages['alertsNewAlert_Bus_NotSet']}
            label={null}
            value={voltages.find((option) => option.id === value.batteryVoltage)}
            options={voltages}
            onChange={(selected) => onChange({ ...value, batteryVoltage: selected?.id })}
            xs={12} sm={3}
          />
        </Grid>

        { /* coolantTemp */}
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
          style={{ width: '100%' }}
        >
          <Grid item xs={12} sm={12} style={{ paddingTop: 10 }}>
            <label>
              {messages['alertsNewAlert_VBus_CoolantTemp']}
            </label>
          </Grid>

          <SliderWrapper
            min={0}
            max={1000}
            value={value.coolantTemp || 0}
            onChange={(selected) => onChange({ ...value, coolantTemp: selected })}
            sliderStep={50}
            xs={12} sm={9}
          />

          <InputWrapper
            id='coolantTemp'
            type={'number'}
            value={value.coolantTemp || ""}
            placeholder={messages['alertsNewAlert_Bus_NotSet']}
            maxLength={4}
            min={0}
            max={1000}
            onChange={(selected) => onChange({ ...value, coolantTemp: selected })}
            xs={12} sm={3}
          />
        </Grid>

        { /* engineSpeed */}
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
          style={{ width: '100%' }}
        >
          <Grid item xs={12} sm={12} style={{ paddingTop: 10 }}>
            <label>
              {messages['alertsNewAlert_VBus_EngineSpeed']}
            </label>
          </Grid>

          <SliderWrapper
            min={0}
            max={10000}
            value={value.engineSpeed || 0}
            onChange={(selected) => onChange({ ...value, engineSpeed: selected })}
            sliderStep={500}
            xs={12} sm={9}
          />

          <SelectWrapper
            id='engineSpeed'
            placeholder={messages['alertsNewAlert_Bus_NotSet']}
            label={null}
            value={rpms.find((option) => option.id === value.engineSpeed)}
            options={rpms}
            onChange={(selected) => onChange({ ...value, engineSpeed: selected?.id })}
            xs={12} sm={3}
          />
        </Grid>

        { /* fuelPercent */}
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
          style={{ width: '100%' }}
        >
          <Grid item xs={12} sm={12} style={{ paddingTop: 10 }}>
            <label>
              {messages['alertsNewAlert_VBus_FuelPercent']}
            </label>
          </Grid>

          <SliderWrapper
            min={0}
            max={100}
            value={value.fuelPercent || 0}
            onChange={(selected) => onChange({ ...value, fuelPercent: selected })}
            sliderStep={5}
            xs={12} sm={9}
          />

          <SelectWrapper
            id='fuelPercent'
            placeholder={messages['alertsNewAlert_Bus_NotSet']}
            label={null}
            value={fuelLevels.find((option) => option.id === value.fuelPercent)}
            options={fuelLevels}
            onChange={(selected) => onChange({ ...value, fuelPercent: selected?.id })}
            xs={12} sm={3}
          />
        </Grid>

        { /* fuelRemain */}
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
          style={{ width: '100%' }}
        >
          <Grid item xs={12} sm={12} style={{ paddingTop: 10 }}>
            <label>
              {messages['alertsNewAlert_VBus_FuelRemain']}
            </label>
          </Grid>

          <SliderWrapper
            min={0}
            max={100}
            value={value.fuelRemain || 0}
            onChange={(selected) => onChange({ ...value, fuelRemain: selected })}
            sliderStep={5}
            xs={12} sm={9}
          />

          <SelectWrapper
            id='fuelRemain'
            placeholder={messages['alertsNewAlert_Bus_NotSet']}
            label={null}
            value={fuelLevels.find((option) => option.id === value.fuelRemain)}
            options={fuelLevels}
            onChange={(selected) => onChange({ ...value, fuelRemain: selected?.id })}
            xs={12} sm={3}
          />
        </Grid>

        { /* tripFuel */}
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
          style={{ width: '100%' }}
        >
          <Grid item xs={12} sm={12} style={{ paddingTop: 10 }}>
            <label>
              {messages['alertsNewAlert_VBus_TripFuel']}
            </label>
          </Grid>

          <SliderWrapper
            min={0}
            max={100}
            value={value.tripFuel || 0}
            onChange={(selected) => onChange({ ...value, tripFuel: selected })}
            sliderStep={5}
            xs={12} sm={9}
          />

          <SelectWrapper
            id='tripFuel'
            placeholder={messages['alertsNewAlert_Bus_NotSet']}
            label={null}
            value={fuelLevels.find((option) => option.id === value.tripFuel)}
            options={fuelLevels}
            onChange={(selected) => onChange({ ...value, tripFuel: selected?.id })}
            xs={12} sm={3}
          />
        </Grid>

        { /* fuelRate */}
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
          style={{ width: '100%' }}
        >
          <Grid item xs={12} sm={12} style={{ paddingTop: 10 }}>
            <label>
              {messages['alertsNewAlert_VBus_FuelRate']}
            </label>
          </Grid>

          <SliderWrapper
            min={0}
            max={5}
            value={value.fuelRate || 0}
            onChange={(selected) => onChange({ ...value, fuelRate: selected })}
            sliderStep={0.5}
            xs={12} sm={9}
          />

          <SelectWrapper
            id='fuelRate'
            placeholder={messages['alertsNewAlert_Bus_NotSet']}
            label={null}
            value={fuelRates.find((option) => option.id === value.fuelRate)}
            options={fuelRates}
            onChange={(selected) => onChange({ ...value, fuelRate: selected?.id })}
            xs={12} sm={3}
          />
        </Grid>

        { /* throttlePosition */}
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
          style={{ width: '100%' }}
        >
          <Grid item xs={12} sm={12} style={{ paddingTop: 10 }}>
            <label>
              {messages['alertsNewAlert_VBus_ThrottlePosition']}
            </label>
          </Grid>

          <SliderWrapper
            min={0}
            max={100}
            value={value.throttlePosition || 0}
            onChange={(selected) => onChange({ ...value, throttlePosition: selected })}
            sliderStep={5}
            xs={12} sm={9}
          />

          <SelectWrapper
            id='throttlePosition'
            placeholder={messages['alertsNewAlert_Bus_NotSet']}
            label={null}
            value={positions.find((option) => option.id === value.throttlePosition)}
            options={positions}
            onChange={(selected) => onChange({ ...value, throttlePosition: selected?.id })}
            xs={12} sm={3}
          />
        </Grid>

        { /* seatbelt */}
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
          style={{ width: '100%' }}
        >
          <Grid item xs={12} sm={12} style={{ paddingTop: 10 }}>
            <label>
              {messages['alertsNewAlert_VBus_Seatbelt']?.replace('SPEED_UM', (isKph ? 'kph' : 'mph'))}
            </label>
          </Grid>

          <SliderWrapper
            min={15}
            max={150}
            value={value.seatbelt || 0}
            onChange={(selected) => { setSeatbeltUM(selected); onChange({ ...value, seatbelt: selected }) }}
            sliderStep={1}
            xs={12} sm={9}
          />

          <SelectWrapper
            id='seatbelt'
            placeholder={messages['alertsNewAlert_Bus_NotSet']}
            label={null}
            value={speeds.find((option) => option.id === value.seatbelt)}
            options={speeds}
            onChange={(selected) => { setSeatbeltUM(selected?.id); onChange({ ...value, seatbelt: selected?.id }) }}
            xs={12} sm={3}
          />
        </Grid>

      </Grid>
    </Form>
  );
}

/** WRAPPERS */
function ToggleSwitchWrapper({ id, label, checked, onChange, xs, sm }) {
  return <Grid item xs={xs} sm={sm}>
    <ToggleSwitch
      id={id}
      small
      blueToggle
      optionLabels={["", ""]}
      label={label}
      checked={checked}
      onChange={onChange}
    />
  </Grid>
}

function SliderWrapper({ min, max, value, onChange, sliderStep, xs, sm }) {
  return <Grid item xs={xs} sm={sm} style={{ paddingRight: 25 }}>
    <Slider
      min={min}
      max={max}
      value={value}
      onChange={onChange}
      sliderOneColor={false}
      valueLabelDisplay={'off'}
      sliderStep={sliderStep}
    />
  </Grid>
}

function InputWrapper({ id, type, placeholder, maxLength, min, max, value, onChange, xs, sm }) {
  return <Grid item xs={xs} sm={sm}>
    <Input
      id={id}
      type={type}
      style={{ width: 'auto' }}
      placeholder={placeholder}
      containerStyle={{ paddingTop: 0 }}
      maxLength={maxLength}
      min={min}
      max={max}
      onlyPositive
      onChange={onChange}
      value={value}
    />
  </Grid>
}

function SelectWrapper({ id, label, placeholder, options, value, onChange, xs, sm }) {
  return <Grid item xs={xs} sm={sm}>
    <Select
      id={id}
      value={value}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      options={options}
      textField="name"
      valueField="id"
      isClearable
      containerStyle={{ paddingTop: 0 }}
    />
  </Grid>
}